import { render, staticRenderFns } from "./BookingAddressForm.vue?vue&type=template&id=2d457404&"
import script from "./BookingAddressForm.vue?vue&type=script&lang=js&"
export * from "./BookingAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports